import React from 'react';
import CONSTANTS from '../../../assets/constants';

const Partners = () => (
  <div className="grid-container">
    <div className="margin-bottom-3">
      <h3 className="margin-vertical-2 text-center">
        {CONSTANTS.COLLABORATION_HEADING}
      </h3>
      <div className="grid-x align-middle align-center">
        <div className="cell shrink">
          <img
            alt={`${CONSTANTS.DR_NAME} Avatar`}
            style={{ width: 126 }}
            className="avatar"
            src={CONSTANTS.AVATAR}
          />
        </div>
        <div className="cell shrink doctor-info">
          <p>{CONSTANTS.DR_NAME}</p>
          <p>{CONSTANTS.DR_STUDY}</p>
          <p>{CONSTANTS.DR_ADDRESS}</p>
        </div>
      </div>
    </div>
  </div>
);

export default Partners;
